// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure QuickSight dashboard fills all available space */
.quicksight-dashboard-full {
  height: 100%;
  width: 100%;
  min-height: 0;
  min-width: 0;
  display: flex;
}
/* Global Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
}

.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

/* QuickSight Dashboard Styles */
.quicksight-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-top: 1rem;
}

.quicksight-error {
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  color: #856404;
}

.quicksight-error h3 {
  margin-bottom: 0.5rem;
}

.quicksight-error button {
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background-color: #ffc107;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

.quicksight-error button:hover {
  background-color: #e0a800;
}

/* Loading Spinner */
.quicksight-loader {
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Responsive */
@media (max-width: 768px) {
  main {
    padding: 1rem !important;
  }
  
  header {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;AACf;AACA,kBAAkB;AAClB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,eAAe;AACf;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;AACF","sourcesContent":["/* Ensure QuickSight dashboard fills all available space */\n.quicksight-dashboard-full {\n  height: 100%;\n  width: 100%;\n  min-height: 0;\n  min-width: 0;\n  display: flex;\n}\n/* Global Styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f5f5f5;\n}\n\n.app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\nmain {\n  flex: 1;\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* QuickSight Dashboard Styles */\n.quicksight-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  margin-top: 1rem;\n}\n\n.quicksight-error {\n  background: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 4px;\n  color: #856404;\n}\n\n.quicksight-error h3 {\n  margin-bottom: 0.5rem;\n}\n\n.quicksight-error button {\n  margin-top: 1rem;\n  padding: 0.5rem 1rem;\n  background-color: #ffc107;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.quicksight-error button:hover {\n  background-color: #e0a800;\n}\n\n/* Loading Spinner */\n.quicksight-loader {\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  main {\n    padding: 1rem !important;\n  }\n  \n  header {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
